import React from "react";
import "./App.css";
import { Container } from "./components/Container";
import { createTheme, ThemeProvider } from "@mui/material";
import { UkuaComponent } from "./components/Ukua";
import { Calendar } from "./components/Calendar";
import { useSelector } from "react-redux";
import { selectPath } from "./store/location";
import { AboutUkua } from "./components/AboutUkua";
import { LoginDialog } from "./components/LoginDialog";
import { References } from "./components/References";
import { InstallApp } from "./components/InstallApp";

const theme = createTheme({
  typography: {
    button: {
      textTransform: "none"
    }
  },
  palette: {
    type: "light",
    primary: {
      main: "#425670",
      light: "#b9c7da",
      dark: "#112947",
    },
    secondary: {
      main: "#901a1e",
    },
  },
});

function App() {
  const path = useSelector(selectPath);
  let route = path[path.length - 1];
  let routes = {
    UKUA: UkuaComponent,
    Calendar: Calendar,
    References: References,
    "About UKUA": AboutUkua,
    "Install App": InstallApp,
  };
  let Component = routes[route] || UkuaComponent;

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
          <Calendar />
      </ThemeProvider>
    </div>
  );
}

export default App;
